/**
 * 对fetch.js进行有业务的二次封装，主要用于ret字段返回的业务处理
 * 返回成功，直接返回数据
 * 当errcode===999则跳转到验证码页面
 * 失败情况返回 {errorNo,errorMsg}
 */
import { get } from 'lodash'
import Fetch from '@lib/utils/fetch.js'
import abLS from '@/business/abLocalStorage'
import Vue from 'vue'
import store from '../module/store'
Fetch.prototype.tjHost = process.host
const $vm = new Vue()

export default new Fetch({
  reqHandle: (req) => {
    const auth = get(store, 'state.currentRoute.matched.1.meta.auth')
    if (auth) {
      req.headers.auth = auth
    }
    if (!req.data.noLoading) {
      $vm.$loading.show()
    } else {
      delete req.data.noLoading
    }
  },
  resHandle: (res, options) => {
    $vm.$loading.hide()
    // 下载，直接是流文件
    if (options && options.responseType === 'blob') {
      return Promise.resolve(res)
    }
    if (res.ret) {
      return Promise.resolve(res.data)
    } else {
      // -99 为需要重新登录
      if (res.errcode === -99) {
        abLS.clearLocalStorage()
        window.location.href = '/login'
      }
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject({
        errorNo: res.errcode,
        errorMsg: res.errmsg || '请求错误'
      })
    }
  }
})
